import React, { Component } from "react";
import Alert from "react-bootstrap/Alert";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { connect } from "react-redux";
import {
  giversFeedbackAction,
  viewGiversFeedback,
} from "../../../../store/actions/userActions";

class GiversModal extends Component {
  state = {
    seekerprivateid: "",
    verified: false,
    summaryreport: "",
    editing: false,
    changed: false,
  };
  handleChange = (e) => {
    if (e.target.name === "summaryreport") this.setState({ changed: true });
    this.setState({ [e.target.name]: e.target.value, error: "" });
  };

  toggleEdit = () => {
    this.setState({ editing: !this.state.editing });
  };

  onSubmit = (approve) => {
    const { id, service } = this.props;
    const { summaryreport } = this.state;
    if (summaryreport === "") {
      this.setState({ error: "Please provide some input" });
      return;
    }
    this.props
      .giversFeedbackAction({ id, service, approve, summaryreport })
      .then((res) => {
        if (res) {
          if (approve === 1) alert("Feedback Approved!");
          else if (approve === -1) alert("Feedback Ignored!");
          else alert("Submitted Successfully!");
          this.props.hide();
        }
      })
      .catch((e) => this.setState({ error: e.message }));
  };

  onVerify = () => {
    //id, service, approve=1, summaryreport
    const { seekerprivateid } = this.state;
    const { id, service } = this.props;
    if (seekerprivateid === "") {
      this.setState({ error: "Please provide Id." });
      return;
    }
    this.props
      .viewGiversFeedback({ id, service, seekerprivateid })
      .then((summaryreport) => this.setState({ summaryreport, verified: true }))
      .catch((e) => this.setState({ error: e.message }));
  };

  render() {
    const myBtn = {
      background: "transparent",
      padding: "0 2rem",
      fontSize: "1rem",
      boxShadow: "none",
      border: "1px solid #4ec8a3",
      color: "#4ec8a3",
      height: "3rem",
    };

    const iconStyle = {
      color: "#4ec8a3",
    };
    const { summaryreport, editing, changed, verified } = this.state;
    return (
      <Modal
        show={this.props.show}
        onHide={this.props.hide}
        aria-labelledby="contained-modal-title-vcenter"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title className="px-lg-4">Coaching Summary</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "2rem" }}>
          <Form>
            <Form.Group controlId="formBasicEmail">
              <Form.Label>Enter your Private Key to view</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your Private Key"
                name="seekerprivateid"
                readOnly={summaryreport}
                onChange={this.handleChange}
              />
            </Form.Group>
          </Form>
          {verified && (
            <Form>
              <Form.Group controlId="formBasicEmail">
                <Row className="p-0 m-0 align-items-center justify-content-between">
                  <Form.Label>Feedback from giver</Form.Label>
                  {editing ? (
                    <i
                      className="fas fa-times cp"
                      style={iconStyle}
                      onClick={this.toggleEdit}
                    ></i>
                  ) : (
                    <i
                      className="fas fa-edit cp"
                      style={iconStyle}
                      onClick={this.toggleEdit}
                    ></i>
                  )}
                </Row>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={summaryreport}
                  name="summaryreport"
                  readOnly={!editing}
                  onChange={this.handleChange}
                />
              </Form.Group>
            </Form>
          )}
          {this.state.error && (
            <Alert variant="danger">{this.state.error}</Alert>
          )}
          {/* Verify submit button */}
          {!verified && (
            <React.Fragment>
              <Row className="justify-content-start m-0">
                <button
                  className="ar-button style-flat mr--20 "
                  style={myBtn}
                  onClick={this.onVerify}
                >
                  <span className="button-text">VERIFY</span>
                </button>
              </Row>
              <Row className="justify-content-center py-1 mx-auto">
                <img src="/assets/images/opening.gif" alt="opening" />
              </Row>
            </React.Fragment>
          )}
          {/* submit edited content button */}
          {verified && changed && (
            <Row className="justify-content-start m-0">
              <button
                className="ar-button style-flat mr--20 "
                style={myBtn}
                onClick={() => this.onSubmit(2)}
              >
                <span className="button-text">SUBMIT</span>
              </button>
            </Row>
          )}
          {/* approve disapprove buttons */}
          {!changed && !editing && verified && (
            <Row className="justify-content-start m-0">
              <button
                className="ar-button style-flat mr--20 "
                style={myBtn}
                onClick={() => this.onSubmit(1)}
              >
                <span className="button-text">APPROVE</span>
              </button>
              <button
                className="ar-button style-flat mr--20 "
                style={myBtn}
                onClick={() => this.onSubmit(-1)}
              >
                <span className="button-text">IGNORE</span>
              </button>
            </Row>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}
const dtp = (dispatch) => {
  return {
    viewGiversFeedback: (data) => dispatch(viewGiversFeedback(data)),
    giversFeedbackAction: (data) => dispatch(giversFeedbackAction(data)),
  };
};
export default connect(null, dtp)(GiversModal);
